import { createNode } from '@glueapp/graph-types';

export const RandomNumber = createNode({
    id: 'Random Number',
    name: 'Random Number',
    description: 'Creates a random number',
    aiDescription:
        'Generates a random number within a range. Connect values to "Range Start" and "Range End" input ports; the "Result" output port provides a random number between them.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        'Range Start': { kind: 'number' },
        'Range End': { kind: 'number' },
    },
    outPorts: {
        Result: { kind: 'number' },
    },
    execute: function (input) {
        const randomValue = Math.random();
        const start = input.inPorts['Range Start'];
        const end = input.inPorts['Range End'];
        const distance = end - start;
        return { output: { Result: randomValue * distance + start } };
    },
});
